import {
  ConfigProvider,
  App as AntdApp,
} from 'antd'


import { useTheme } from './hooks/useTheme'
import { ThemeProvider } from 'antd-style'

// 定义深色主题和浅色主题的算法
import darkAlgorithm from 'antd/es/theme/themes/dark'
import defaultAlgorithm from 'antd/es/theme/themes/default'

import { LoginModal } from '@/pages/login/LoginModal'
import RouterProvider from './routers/index.tsx'
// 创建自定义主题配置
const customTheme = {
  token: {
    colorPrimary: '#1677ff',
    borderRadius: 6,
  },
}

const App = () => {
  const { actualTheme } = useTheme()
  const isDark = actualTheme === 'dark'

  return (
    <ConfigProvider
      theme={{
        ...customTheme,
        algorithm: isDark ? darkAlgorithm : defaultAlgorithm,
      }}
    >
      <AntdApp>
        <ThemeProvider
          appearance={actualTheme}
          themeMode={actualTheme}
          theme={customTheme}
        >
          <RouterProvider />
          <LoginModal />
        </ThemeProvider>
      </AntdApp>
    </ConfigProvider>
  )
}

export default App
